<template>
  <div class="mall-container">
    <!-- 侧边栏 -->
    <aside class="sidebar" :class="{ collapsed: sidebarCollapsed }">
      <div class="sidebar-header">
        <div class="logo" @click="$router.push('/dashboard')">
          <i class="fas fa-graduation-cap"></i>
          <span v-show="!sidebarCollapsed">智慧迎新</span>
        </div>
        <button class="toggle-btn" @click="sidebarCollapsed = !sidebarCollapsed">
          <i :class="sidebarCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
        </button>
      </div>
      <nav class="sidebar-nav">
        <a href="#" @click.prevent="$router.push('/dashboard')" :class="{ active: $route.path === '/dashboard' }">
          <i class="fas fa-tachometer-alt"></i>
          <span v-show="!sidebarCollapsed">仪表盘</span>
        </a>
        <a href="#" @click.prevent="$router.push('/tasks')" :class="{ active: $route.path === '/tasks' }">
          <i class="fas fa-tasks"></i>
          <span v-show="!sidebarCollapsed">我的任务</span>
        </a>
        <a href="#" @click.prevent="$router.push('/mall')" :class="{ active: $route.path === '/mall' }">
          <i class="fas fa-store"></i>
          <span v-show="!sidebarCollapsed">积分商城</span>
        </a>
        <a href="#" @click.prevent="openProfile">
          <i class="fas fa-user-circle"></i>
          <span v-show="!sidebarCollapsed">个人资料</span>
        </a>
      </nav>
      <div class="sidebar-footer">
        <button @click="logout" class="logout-btn">
          <i class="fas fa-sign-out-alt"></i>
          <span v-show="!sidebarCollapsed">退出登录</span>
        </button>
      </div>
    </aside>

    <!-- 主内容 -->
    <main class="main-content">
      <header class="top-bar">
        <div class="welcome">
          <h2>积分商城</h2>
          <p>用积分兑换心仪好物 🎁</p>
        </div>
        <div class="user-info">
          <div class="points-badge">
            <i class="fas fa-star"></i>
            <span>{{ userPoints }} 积分</span>
          </div>
          <div class="avatar">
            <i class="fas fa-user-circle"></i>
          </div>
        </div>
      </header>

      <!-- 商品列表 -->
      <div class="goods-section">
        <div class="section-header">
          <h3><i class="fas fa-gift"></i> 精选好物</h3>
        </div>

        <div v-if="loading" class="loading-state">
          <i class="fas fa-spinner fa-spin"></i> 加载中...
        </div>

        <div v-else class="goods-grid">
          <div v-for="item in goodsList" :key="item.id" class="goods-card">
            <div class="goods-icon" :style="{ background: item.bgColor }">
              <i :class="item.icon"></i>
            </div>
            <div class="goods-info">
              <h4>{{ item.name }}</h4>
              <p>{{ item.description }}</p>
              <div class="goods-footer">
                <span class="goods-price">
                  <i class="fas fa-star"></i> {{ item.points }}
                </span>
                <button
                  class="exchange-btn"
                  :disabled="userPoints < item.points || item.stock === 0"
                  @click="exchange(item)"
                >
                  {{ userPoints >= item.points && item.stock > 0 ? '兑换' : (item.stock === 0 ? '已售罄' : '积分不足') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="!loading && goodsList.length === 0" class="empty-state">
          <i class="fas fa-box-open"></i>
          <p>暂无商品，敬请期待~</p>
        </div>
      </div>

      <!-- 兑换记录 -->
      <div class="history-section">
        <div class="section-header">
          <h3><i class="fas fa-history"></i> 兑换记录</h3>
          <button @click="loadHistory" class="refresh-btn">
            <i class="fas fa-sync-alt"></i> 刷新
          </button>
        </div>

        <div v-if="historyLoading" class="loading-state small">
          <i class="fas fa-spinner fa-spin"></i> 加载中...
        </div>

        <div v-else-if="historyList.length === 0" class="empty-state small">
          <p>暂无兑换记录</p>
        </div>

        <div v-else class="history-list">
          <div v-for="record in historyList" :key="record.id" class="history-item">
            <div class="history-icon">
              <i class="fas fa-exchange-alt"></i>
            </div>
            <div class="history-info">
              <div class="history-name">{{ record.goodsName }}</div>
              <div class="history-time">{{ record.exchangeTime }}</div>
            </div>
            <div class="history-points">-{{ record.points }} 积分</div>
          </div>
        </div>
      </div>
    </main>

    <!-- 弹窗：编辑个人资料 -->
    <div v-if="profileDialog" class="modal-overlay" @click="profileDialog = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>编辑个人信息</h3>
          <button @click="profileDialog = false" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>用户名</label>
            <input v-model="editForm.username" disabled>
          </div>
          <div class="form-group">
            <label>邮箱</label>
            <input v-model="editForm.email" type="email">
          </div>
          <div class="form-group">
            <label>手机号</label>
            <input v-model="editForm.phone" type="tel">
          </div>
        </div>
        <div class="modal-footer">
          <button @click="profileDialog = false" class="cancel-btn">取消</button>
          <button @click="saveProfile" class="save-btn">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallView',
  data() {
    return {
      sidebarCollapsed: false,
      loading: false,
      historyLoading: false,
      userPoints: 0,
      goodsList: [
        {
          id: 1,
          name: '定制笔记本',
          description: '精美校园定制笔记本，记录你的大学生活',
          points: 50,
          stock: 20,
          icon: 'fas fa-book',
          bgColor: 'linear-gradient(135deg, #667eea, #764ba2)'
        },
        {
          id: 2,
          name: '咖啡券',
          description: '校园咖啡厅兑换券，享受悠闲时光',
          points: 80,
          stock: 15,
          icon: 'fas fa-mug-hot',
          bgColor: 'linear-gradient(135deg, #f093fb, #f5576c)'
        },
        {
          id: 3,
          name: '定制U盘',
          description: '16GB 定制U盘，学习资料随身带',
          points: 120,
          stock: 10,
          icon: 'fas fa-usb',
          bgColor: 'linear-gradient(135deg, #4facfe, #00f2fe)'
        },
        {
          id: 4,
          name: '帆布包',
          description: '定制帆布包，环保时尚',
          points: 150,
          stock: 8,
          icon: 'fas fa-bag-shopping',
          bgColor: 'linear-gradient(135deg, #43e97b, #38f9d7)'
        },
        {
          id: 5,
          name: '蓝牙耳机',
          description: '无线蓝牙耳机，运动学习好伴侣',
          points: 300,
          stock: 5,
          icon: 'fas fa-headphones',
          bgColor: 'linear-gradient(135deg, #fa709a, #fee140)'
        },
        {
          id: 6,
          name: '校园文化衫',
          description: '限量版校园文化衫，值得收藏',
          points: 200,
          stock: 12,
          icon: 'fas fa-tshirt',
          bgColor: 'linear-gradient(135deg, #a18cd1, #fbc2eb)'
        }
      ],
      historyList: [],
      profileDialog: false,
      editForm: { username: '', email: '', phone: '' },
      userInfo: {}
    }
  },
  created() {
    this.loadUserInfo()
    this.loadPoints()
    this.loadHistory()
  },
  methods: {
    loadUserInfo() {
      const userStr = localStorage.getItem('user')
      if (userStr) {
        this.userInfo = JSON.parse(userStr)
        this.editForm = { ...this.userInfo }
      } else {
        this.$router.push('/login')
      }
    },
    goToMall() {
      this.$router.push('/mall')
    },
    async loadPoints() {
      try {
        const token = localStorage.getItem('token')
        const res = await this.$axios.get('/api/points/my', {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          this.userPoints = res.data.data.points
        }
      } catch (error) {
        console.error('获取积分失败', error)
      }
    },
    async loadHistory() {
      this.historyLoading = true
      try {
        // 从本地存储获取兑换记录
        const records = localStorage.getItem('exchange_history')
        if (records) {
          this.historyList = JSON.parse(records)
        } else {
          this.historyList = []
        }
      } catch (error) {
        console.error('加载记录失败', error)
      } finally {
        this.historyLoading = false
      }
    },
    exchange(item) {
      if (this.userPoints < item.points) {
        this.$message.warning(`积分不足，还差 ${item.points - this.userPoints} 积分`)
        return
      }
      if (item.stock === 0) {
        this.$message.warning('商品已售罄')
        return
      }

      this.$confirm(`确定要兑换 ${item.name} 吗？需要 ${item.points} 积分。`, '确认兑换', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {
          const token = localStorage.getItem('token')
          // 扣除积分
          const res = await this.$axios.post('/api/points/add',
            { points: -item.points },
            { headers: { Authorization: `Bearer ${token}` } }
          )
          if (res.data.code === 200) {
            // 更新本地积分
            this.userPoints -= item.points
            // 减少库存
            item.stock--
            // 记录兑换历史
            const newRecord = {
              id: Date.now(),
              goodsName: item.name,
              points: item.points,
              exchangeTime: new Date().toLocaleString()
            }
            this.historyList.unshift(newRecord)
            // 保存到本地存储
            localStorage.setItem('exchange_history', JSON.stringify(this.historyList))
            this.$message.success(`兑换成功！已扣除 ${item.points} 积分`)
            this.loadPoints()
          } else {
            this.$message.error(res.data.message || '兑换失败')
          }
        } catch (error) {
          console.error('兑换失败', error)
          this.$message.error('兑换失败，请稍后重试')
        }
      }).catch(() => {})
    },
    openProfile() {
      this.profileDialog = true
    },
    async saveProfile() {
      try {
        const token = localStorage.getItem('token')
        const res = await this.$axios.put('/api/user/profile',
          { email: this.editForm.email, phone: this.editForm.phone },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        if (res.data.code === 200) {
          this.userInfo = { ...this.editForm }
          localStorage.setItem('user', JSON.stringify(this.userInfo))
          this.profileDialog = false
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.data.message || '保存失败')
        }
      } catch (error) {
        console.error('保存失败', error)
        this.$message.error('保存失败')
      }
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.mall-container {
  display: flex;
  min-height: 100vh;
  background: #f5f7fb;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 侧边栏样式 */
.sidebar {
  width: 260px;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  z-index: 100;
}

.sidebar.collapsed {
  width: 70px;
}

.sidebar-header {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.logo i {
  font-size: 28px;
  color: #667eea;
}

.logo span {
  font-size: 18px;
  font-weight: 600;
}

.toggle-btn {
  background: rgba(255,255,255,0.1);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-nav {
  flex: 1;
  padding: 20px 0;
}

.sidebar-nav a {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  color: rgba(255,255,255,0.7);
  text-decoration: none;
  transition: all 0.3s;
  margin: 4px 12px;
  border-radius: 12px;
  cursor: pointer;
}

.sidebar-nav a i {
  width: 20px;
  font-size: 18px;
}

.sidebar-nav a:hover,
.sidebar-nav a.active {
  background: rgba(102, 126, 234, 0.2);
  color: #667eea;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255,255,255,0.05);
  border: none;
  color: rgba(255,255,255,0.7);
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.logout-btn:hover {
  background: rgba(220, 53, 69, 0.2);
  color: #dc3545;
}

/* 主内容区 */
.main-content {
  flex: 1;
  margin-left: 260px;
  transition: margin-left 0.3s ease;
}

.sidebar.collapsed + .main-content {
  margin-left: 70px;
}

.top-bar {
  background: white;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.welcome h2 {
  font-size: 20px;
  margin-bottom: 4px;
}

.welcome p {
  color: #888;
  font-size: 14px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.points-badge {
  background: linear-gradient(135deg, #ffd89b, #c7e9fb);
  padding: 8px 16px;
  border-radius: 30px;
  color: #333;
  font-weight: 600;
}

.points-badge i {
  color: #ffc107;
  margin-right: 6px;
}

.avatar i {
  font-size: 40px;
  color: #667eea;
}

/* 商品区域 */
.goods-section, .history-section {
  background: white;
  margin: 0 30px 30px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.section-header {
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-header h3 {
  margin: 0;
}

.section-header h3 i {
  margin-right: 8px;
  color: #667eea;
}

.refresh-btn {
  background: #f5f5f5;
  border: none;
  padding: 6px 12px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
}

.goods-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  padding: 24px;
}

.goods-card {
  display: flex;
  gap: 16px;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 16px;
  transition: all 0.2s;
}

.goods-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  border-color: transparent;
}

.goods-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.goods-icon i {
  font-size: 28px;
  color: white;
}

.goods-info {
  flex: 1;
}

.goods-info h4 {
  margin: 0 0 6px;
  font-size: 16px;
}

.goods-info p {
  margin: 0 0 12px;
  font-size: 13px;
  color: #888;
  line-height: 1.4;
}

.goods-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.goods-price {
  font-weight: 700;
  color: #ff9800;
  font-size: 16px;
}

.goods-price i {
  font-size: 12px;
  margin-right: 4px;
}

.exchange-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 6px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.exchange-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.exchange-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 历史记录 */
.history-list {
  padding: 0 20px;
}

.history-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.history-icon {
  width: 40px;
  height: 40px;
  background: #f5f5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
}

.history-info {
  flex: 1;
}

.history-name {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
}

.history-time {
  font-size: 12px;
  color: #999;
}

.history-points {
  color: #ff9800;
  font-weight: 600;
  font-size: 14px;
}

.loading-state, .empty-state {
  text-align: center;
  padding: 60px;
  color: #999;
}

.loading-state.small, .empty-state.small {
  padding: 30px;
}

.loading-state i, .empty-state i {
  font-size: 32px;
  margin-bottom: 10px;
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 20px;
  width: 90%;
  max-width: 450px;
  animation: modalFade 0.2s ease;
}

@keyframes modalFade {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 24px;
}

.modal-body .form-group {
  margin-bottom: 16px;
}

.modal-body label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
}

.modal-body input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-sizing: border-box;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn, .save-btn {
  padding: 10px 24px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
}

.cancel-btn {
  background: #f5f5f5;
}

.save-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}
</style>